module.exports = __webpack_public_path__ + "static/img/bestImg4.58e5ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/bestImg4.png
// module id = cUxz
// module chunks = 1